import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import EventFormContainer from "../EventFormContainer/EventFormContainer";

function EventFormModalContainer({ event, visible, onClose, onEventCreated }) {
  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true} title="Event Details">
      <EventFormContainer event={event} onComplete={onClose} onEventCreated={onEventCreated} />
    </CustomModal>
  );
}

export default EventFormModalContainer;
